import {FC, useState} from 'react'
import {SAVContext} from '../../../@types'
import {useTicketStatus} from '../../../features'

const SAVProvider: FC = ({children}) => {

  const [reloadKey, setReloadKey] = useState<number>(0)
  const {status, urgency} = useTicketStatus()
  const triggerReload = () => setReloadKey(prevState => prevState + 1)


  return (
    <SAVContext.Provider value={{reloadKey, triggerReload, status, urgency}}>{children}</SAVContext.Provider>
  )
}

export {SAVProvider}